module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"email":"Email","warning":"Verification will be required after change","emailSaved":"New email was saved. Please verify it by link in email.","change":"Change","errors":{"email":{"required":"Email is required","email":"Please provide correct email","unique":"Somebody already registered with this email"}}}}')
  delete Component.options._Ctor
}
